import React, { useState } from 'react';

import CreditsCost from '@repo/editor/src/components/CreditsCost/CreditsCost';
import SliderInput from '@repo/editor/src/components/SliderInput/SliderInput';
import {
  ActionsWithCost,
  creditsCostUtil,
} from '@repo/editor/src/utils/credits';
import { withEventScope } from '@repo/event-processor';
import BucketIcon from '@repo/ui/components/Icon/BucketIcon';
import { Spacer } from '@repo/ui/components/Spacer';
import { H6, P2 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';

import RightPanel from 'components/AiTools/RigthPanel/RightPanel';
import { TabDetails } from 'components/AiTools/RigthPanel/types';
import { FlexColumn, FlexRow } from 'styles/layouts';

import { ExpandedContentSlider } from '../VectorizerTool/styles';

import { ColorIcon, ColorIconWrapper, ColorSelection, Wrapper } from './styles';
import { SettingsProps } from './types';

const tabs: TabDetails<'settings'>[] = [
  {
    id: 'settings',
    width: '79px',
    icon: BucketIcon,
    label: 'Settings',
  },
];

const colorsOptions = [
  {
    id: 'blackWhite',
    icon: 'blackWhiteIcon.svg',
    label: 'B/W',
  },
  {
    id: 'color',
    icon: 'colorIcon.svg',
    label: 'Multicolor',
  },
] as const;

export type VectorizerOptions = (typeof colorsOptions)[number]['id'];
const DEFAULT_COLOR_COUNT = 7;

const Settings: React.FC<SettingsProps> = (props) => {
  const [activeSelection, setActiveSelection] =
    useState<VectorizerOptions>('color');
  const [colorCount, setColorCount] = useState(DEFAULT_COLOR_COUNT);

  const creditCost = (
    <CreditsCost
      color={props.disabled ? themeStyle.varInkMedium : themeStyle.varInkBase}
      cost={creditsCostUtil[ActionsWithCost.SvgConverterWebsite]}
    />
  );
  const showCreditCost = !props.userPlan && !props.disabled;

  return (
    <RightPanel
      smallFooter
      buttonIcon={showCreditCost ? creditCost : undefined}
      buttonLabel={props.isLoading ? 'Vectorizing Image' : 'Vectorize Image'}
      disabled={props.disabled || !activeSelection}
      isLoading={props.isLoading}
      tabs={tabs}
      onClick={(): void =>
        activeSelection && props.onVectorizeClick(activeSelection, colorCount)
      }
    >
      <Wrapper>
        <H6>Color mode</H6>
        <Spacer height="8px" />
        <FlexColumn gap="8px">
          {colorsOptions.map((option) => (
            <ColorSelection
              key={option.id}
              isActive={activeSelection === option.id}
              onClick={(): void => setActiveSelection(option.id)}
            >
              <FlexRow alignItems="center" gap="12px">
                <ColorIconWrapper>
                  <ColorIcon src={`/images/vectorizer/${option.icon}`} />
                </ColorIconWrapper>
                <P2 style={{ fontWeight: themeStyle.fontMedium }}>
                  {option.label}
                </P2>
              </FlexRow>
            </ColorSelection>
          ))}
          {activeSelection === 'color' && (
            <ExpandedContentSlider>
              <SliderInput
                disabled={false}
                label="Colors"
                max={16}
                min={1}
                name="color-count"
                precision={0}
                startValue={colorCount}
                onChanged={setColorCount}
              />
            </ExpandedContentSlider>
          )}
        </FlexColumn>
      </Wrapper>
    </RightPanel>
  );
};

export default withEventScope(Settings, { module: 'vectorizerSettings' });
